module.exports = __webpack_public_path__ + "static/img/default-avatar.37c3ea6b.png";